import { FC, useMemo } from 'react';
import { Threshold } from './models';
import { MAGNETIC_TOKENS } from '@appd/uik';
import { DEFAULT_THRESHOLDS } from './constants';
import { useThreshold } from './useThreshold';

const { COLORS } = MAGNETIC_TOKENS;

interface TextColorCellRendererProps {
  value: string;
  thresholds: Threshold[];
}

export const TextColorCellRenderer: FC<TextColorCellRendererProps> = ({
  value,
  thresholds = DEFAULT_THRESHOLDS,
}): JSX.Element => {
  const threshold = useThreshold(thresholds, value);
  const color = useMemo(() => threshold && threshold.color, [threshold]);

  return <p style={{ color: color ?? COLORS.DEFAULT_TEXT }}>{value}</p>;
};
